import { render, staticRenderFns } from "./labelInfo.vue?vue&type=template&id=4aaae862&scoped=true&"
import script from "./labelInfo.vue?vue&type=script&lang=js&"
export * from "./labelInfo.vue?vue&type=script&lang=js&"
import style0 from "./labelInfo.vue?vue&type=style&index=0&id=4aaae862&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaae862",
  null
  
)

export default component.exports